/** @format */

import { Box, List, ListItem, Typography } from '@mui/material';
import { map } from 'lodash';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BookingRequestNotice from 'src/components/notice/booking-request';
import { Scrollbar } from 'src/components/scrollbar';
import { notificationActions } from 'src/config';
import { useBookingRequestAction } from 'src/hooks/use-booking-request-action';
import { selectBookingNoticepPopoverCheckFocus, setBookingRequestPopoverRemoveFocus } from '../booking-notice.slice';

export const RequestNew = ({ requests }) => {
  // const store = useStore();
  const isEmpty = requests.length === 0;

  // useEffect(() => {
  //   if (open === true) {
  //     const bookingNotice = store.getState().bookingNotice;
  //     const toastIds = get(bookingNotice, `toastIds`, []);

  //     map(toastIds, (toastId) => {
  //       toast.dismiss(toastId);
  //     });
  //   }
  // }, [open]);

  return (
    <>
      {isEmpty ? (
        <Box sx={{ p: 2 }}>
          <Typography variant="subtitle2">Chưa có kèo mới</Typography>
        </Box>
      ) : (
        <RequestNewList requests={requests} />
      )}
    </>
  );
};

export const RequestNewList = ({ requests }) => {
  const dispatch = useDispatch();
  const { handleConfirm } = useBookingRequestAction();

  const handleHoverRemoveFocus = useCallback(() => {
    dispatch(setBookingRequestPopoverRemoveFocus());
  }, []);

  return (
    <Scrollbar sx={{ maxHeight: 'calc(100vh - 150px)' }}>
      <List disablePadding>
        {map(requests, (request) => (
          <RequestNewItem key={request.id} request={request} handleConfirm={handleConfirm} onHover={handleHoverRemoveFocus} />
        ))}
      </List>
    </Scrollbar>
  );
};

export const RequestNewItem = ({ request, handleConfirm, onHover }) => {
  const isFocus = useSelector((state) => selectBookingNoticepPopoverCheckFocus(state, request.id));
  return (
    <ListItem
      divider
      key={request.id}
      sx={{
        alignItems: 'flex-start',
        wordBreak: 'break-word',
        ...(isFocus && {
          backgroundColor: 'action.focus'
        }),
        '&:hover': {
          backgroundColor: 'action.hover'
        },
        '& .MuiListItemSecondaryAction-root': {
          top: '14%'
        }
        // ...(unread && { background: '#deff7a12' })
      }}
      {...(isFocus && {
        onMouseOver: onHover
      })}
      // secondaryAction={
      //   <Tooltip title="Bỏ qua">
      //     <IconButton edge="end" onClick={() => onConfirm?.(request.id)} size="small">
      //       <SvgIcon>
      //         <XIcon />
      //       </SvgIcon>
      //     </IconButton>
      //   </Tooltip>
      // }
    >
      <BookingRequestNotice content={request} onConfirm={handleConfirm} pushAction={notificationActions.BOOKING_REQUEST_NEW} />
    </ListItem>
  );
};

export default RequestNew;
